/**
 * AllAll Midjourney 图片：POST /mj/submit/imagine 提交，GET /mj/task/{taskId}/fetch 轮询
 * 参数：botType(MID_JOURNEY|NIJI_JOURNEY), prompt(必填), base64Array, notifyHook, state
 */
var BOT_TYPES = ['MID_JOURNEY', 'NIJI_JOURNEY']

export function normalizeBotType(v) {
  if (!v || typeof v !== 'string') return 'MID_JOURNEY'
  var s = String(v).trim().toLowerCase()
  if (s === 'anime' || s === 'niji' || s === 'niji_journey') return 'NIJI_JOURNEY'
  if (s === 'realistic' || s === 'real' || s === 'mid_journey') return 'MID_JOURNEY'
  var upper = String(v).trim().toUpperCase()
  return BOT_TYPES.indexOf(upper) !== -1 ? upper : 'MID_JOURNEY'
}

/**
 * 构建 POST /mj/submit/imagine 的 JSON Body
 * @param {Object} params - prompt(必填), botType/style(realistic|anime), base64Array/referenceImagesBase64, notifyHook, state
 */
export function buildBody(params) {
  var prompt = (params.prompt || '').trim()
  if (!prompt) throw new Error('prompt 必填')
  var botType = normalizeBotType(params.botType || params.mjBotType || params.style)
  var body = {
    botType: botType,
    prompt: prompt,
    base64Array: Array.isArray(params.base64Array) ? params.base64Array : (Array.isArray(params.referenceImagesBase64) ? params.referenceImagesBase64 : [])
  }
  if (params.notifyHook != null && String(params.notifyHook).trim()) {
    body.notifyHook = String(params.notifyHook).trim()
  } else {
    body.notifyHook = ''
  }
  if (params.state != null && String(params.state).trim()) {
    body.state = String(params.state).trim()
  } else {
    body.state = ''
  }
  return body
}

/**
 * 解析 GET /mj/task/{taskId}/fetch 的响应
 * 响应体：status(SUCCESS/IN_PROGRESS/FAILURE), imageUrl, failReason
 * 注意：getAiClient 的 response 拦截器已返回 res.data，故 res 可能直接是响应体
 */
export function parsePollResponse(res) {
  var data = res && (typeof res.status !== 'undefined' ? res : res.data)
  if (!data || typeof data !== 'object') return { status: 'waiting' }
  var status = (data.status || '').toUpperCase()
  if (status === 'SUCCESS') {
    return { status: 'completed', url: data.imageUrl || '' }
  }
  if (status === 'FAILURE' || status === 'FAILED' || status === 'CANCELED') {
    return { status: 'failed', error: (data.failReason && String(data.failReason)) || '生成失败' }
  }
  return { status: 'waiting' }
}
